/* eslint-disable no-empty-pattern */
import {call, put, delay, select} from 'redux-saga/effects'
import {push} from 'connected-react-router'
import SettingsActions from '../Redux/SettingsRedux'
import AuthActions, {AuthSelectors} from '../Redux/AuthRedux'
import ErrorsActions from '../Redux/ErrorsRedux'

import utils from '../Utils/utils'

export function* getCountries(api, authApi, {}) {
  try {
    const response = yield call(api.getCountries)
    if (response && response.ok) {
      yield put(SettingsActions.countriesSuccess(response.data))
    } else {
      if (response && response.data) {
        if (response.status === 401) {
          yield put(ErrorsActions.errorSave(null))
        } else if (response.status === 500) {
          yield put(ErrorsActions.errorSave('Server response error'))
        } else {
          yield put(ErrorsActions.errorSave(response.data))
        }
      } else {
        yield put(ErrorsActions.errorSave('Server response error'))
      }
      yield put(SettingsActions.settingsFetchingReset())
    }

    if (response && response.status === 401) {
      const res = yield call(authApi.tokenRefresh)
      if (res && res.access) {
        yield put(AuthActions.updateTokens(res.access, res.refresh))
        yield* getCountries(api, authApi, {})
      } else {
        yield put(AuthActions.logout())
        yield put(push('/login'))
      }
    }
  } catch (e) {
    yield put(SettingsActions.settingsFetchingReset())
    yield put(ErrorsActions.errorSave('Server response error: ' + e))
  }
}

export function* getSubscriptions(api, authApi, {}) {
  try {
    const response = yield call(api.getSubscriptions)
    if (response && response.ok) {
      //let mapSubscriptions = response.data.reduce((accumulator, currentValue) => ({...accumulator, [currentValue.id]: {...currentValue}}), {})

      yield put(SettingsActions.subscriptionsSuccess(response.data))
    } else {
      if (response && response.data) {
        if (response.status === 401) {
          yield put(ErrorsActions.errorSave(null))
        } else if (response.status === 500) {
          yield put(ErrorsActions.errorSave('Server response error'))
        } else {
          yield put(ErrorsActions.errorSave(response.data))
        }
      } else {
        yield put(ErrorsActions.errorSave('Server response error'))
      }
      yield put(SettingsActions.settingsFetchingReset())
    }

    if (response && response.status === 401) {
      const res = yield call(authApi.tokenRefresh)
      if (res && res.access) {
        yield put(AuthActions.updateTokens(res.access, res.refresh))
        yield* getSubscriptions(api, authApi, {})
      } else {
        yield put(AuthActions.logout())
        yield put(push('/login'))
      }
    }
  } catch (e) {
    yield put(SettingsActions.settingsFetchingReset())
    yield put(ErrorsActions.errorSave('Server response error: ' + e))
  }
}

export function* savePaymentMethod(api, authApi, {data}) {
  try {
    const response = yield call(api.savePaymentMethod, data)
    if (response && response.ok) {
      yield put(SettingsActions.savePaymentMethodSuccess(true))
      yield put(AuthActions.updateProfile(response.data))
    } else {
      if (response && response.data) {
        if (response.status === 401) {
          yield put(ErrorsActions.errorSave(null))
        } else if (response.status === 402) {
          yield put(SettingsActions.savePaymentMethodSecure(response.data))
          utils.goLink(response.data.link)
        } else if (response.status === 500) {
          yield put(SettingsActions.savePaymentMethodFailure(true))
          // yield put(ErrorsActions.errorSave(response.data))
          yield put(ErrorsActions.errorSave('Server response error'))
        } else {
          //yield put(ErrorsActions.errorSave(response.data))
          yield put(ErrorsActions.errorSave('Server response error'))
        }
      } else {
        yield put(ErrorsActions.errorSave('Server response error'))
      }
      yield put(SettingsActions.settingsFetchingReset())
    }

    if (response && response.status === 401) {
      const res = yield call(authApi.tokenRefresh)
      if (res && res.access) {
        yield put(AuthActions.updateTokens(res.access, res.refresh))
        yield* savePaymentMethod(api, authApi, {data})
      } else {
        yield put(AuthActions.logout())
        yield put(push('/login'))
      }
    }
  } catch (e) {
    yield put(SettingsActions.settingsFetchingReset())
    yield put(ErrorsActions.errorSave('Server response error: ' + e))
  }
}

export function* buySubscription(api, authApi, {data}) {
  try {
    const response = yield call(api.buySubscription, data)
    if (response && response.ok) {
      if (response.data.paid) {
        yield put(SettingsActions.buySubscriptionSuccess({paid: true}))
        yield put(AuthActions.updateProfile(response.data?.user))
      } else {
        yield put(SettingsActions.buySubscriptionSecure(response.data))
      }
    } else {
      if (response && response.data) {
        if (response.status === 401) {
          yield put(ErrorsActions.errorSave(null))
        } else if (response.status === 402) {
          yield put(SettingsActions.buySubscriptionSecure(response.data))
          utils.goLink(response.data.link)
        } else if (response.status === 500) {
          yield put(SettingsActions.buySubscriptionFailure(true))
          yield put(ErrorsActions.errorSave(response.data))
        } else {
          yield put(ErrorsActions.errorSave(response.data))
        }
      } else {
        yield put(ErrorsActions.errorSave('Server response error'))
      }
      yield put(SettingsActions.settingsFetchingReset())
    }

    if (response && response.status === 401) {
      const res = yield call(authApi.tokenRefresh)
      if (res && res.access) {
        yield put(AuthActions.updateTokens(res.access, res.refresh))
        yield* buySubscription(api, authApi, {data})
      } else {
        yield put(AuthActions.logout())
        yield put(push('/login'))
      }
    }
  } catch (e) {
    yield put(SettingsActions.settingsFetchingReset())
    yield put(ErrorsActions.errorSave('Server response error: ' + e))
  }
}

export function* updateSubscription(api, authApi, {data}) {
  try {
    const response = yield call(api.updateSubscription, data)
    if (response && response.ok) {
      if (!response.data.paid) {
        yield put(SettingsActions.updateSubscriptionSuccess({paid: true}))
        yield put(AuthActions.updateProfile(response.data?.user))
      } else {
        yield put(SettingsActions.updateSubscriptionSecure(response.data))
      }
    } else {
      if (response && response.data) {
        if (response.status === 401) {
          yield put(ErrorsActions.errorSave(null))
        } else if (response.status === 402) {
          yield put(SettingsActions.updateSubscriptionSecure(response.data))
          utils.goLink(response.data.link)
        } else if (response.status === 500) {
          yield put(SettingsActions.updateSubscriptionFailure(true))
          //yield put(ErrorsActions.errorSave(response.data))
          yield put(ErrorsActions.errorSave('Server response error'))
        } else {
          yield put(ErrorsActions.errorSave(response.data))
        }
      } else {
        yield put(ErrorsActions.errorSave('Server response error'))
      }
      yield put(SettingsActions.settingsFetchingReset())
    }

    if (response && response.status === 401) {
      const res = yield call(authApi.tokenRefresh)
      if (res && res.access) {
        yield put(AuthActions.updateTokens(res.access, res.refresh))
        yield* updateSubscription(api, authApi, {data})
      } else {
        yield put(AuthActions.logout())
        yield put(push('/login'))
      }
    }
  } catch (e) {
    yield put(SettingsActions.settingsFetchingReset())
    yield put(ErrorsActions.errorSave('Server response error: ' + e))
  }
}

export function* deleteScheduledSubscription(api, authApi, {}) {
  try {
    const response = yield call(api.deleteScheduledSubscription)
    if (response && response.ok) {
      yield put(SettingsActions.deleteScheduledSubscriptionSuccess(true))
      let state = yield select(AuthSelectors.getUserInfo)
      let data = {...state, subscription: {...state.subscription, scheduled_subscription: null, scheduled_subscribed_monthly: null}}
      yield put(AuthActions.updateProfile(data))
    } else {
      if (response && response.data) {
        if (response.status === 401) {
          yield put(ErrorsActions.errorSave(null))
        } else if (response.status === 500) {
          yield put(ErrorsActions.errorSave('Server response error'))
        } else {
          yield put(ErrorsActions.errorSave(response.data))
        }
      } else {
        yield put(ErrorsActions.errorSave('Server response error'))
      }
      yield put(SettingsActions.settingsFetchingReset())
    }

    if (response && response.status === 401) {
      const res = yield call(authApi.tokenRefresh)
      if (res && res.access) {
        yield put(AuthActions.updateTokens(res.access, res.refresh))
        yield* deleteScheduledSubscription(api, authApi, {})
      } else {
        yield put(AuthActions.logout())
        yield put(push('/login'))
      }
    }
  } catch (e) {
    yield put(SettingsActions.settingsFetchingReset())
    yield put(ErrorsActions.errorSave('Server response error: ' + e))
  }
}

export function* saveCompanyInfo(api, authApi, {data}) {
  try {
    //yield delay(2000)
    //yield put(SettingsActions.saveCompanyInfoSuccess(true))
    //yield put(AuthActions.updateProfile({company_info: data}))

    const response = yield call(api.saveCompanyInfo, data)
    if (response && response.ok) {
      yield put(SettingsActions.saveCompanyInfoSuccess(true))
      yield put(AuthActions.updateProfile({company_info: response.data}))
    } else {
      if (response && response.data) {
        if (response.status === 401) {
          yield put(ErrorsActions.errorSave(null))
        } else if (response.status === 500) {
          yield put(ErrorsActions.errorSave(response.data))
        } else {
          yield put(ErrorsActions.errorSave(response.data))
        }
      } else {
        yield put(ErrorsActions.errorSave('Server response error'))
      }
      yield put(SettingsActions.settingsFetchingReset())
    }

    if (response && response.status === 401) {
      const res = yield call(authApi.tokenRefresh)
      if (res && res.access) {
        yield put(AuthActions.updateTokens(res.access, res.refresh))
        yield* saveCompanyInfo(api, authApi, {data})
      } else {
        yield put(AuthActions.logout())
        yield put(push('/login'))
      }
    }
  } catch (e) {
    yield put(SettingsActions.settingsFetchingReset())
    yield put(ErrorsActions.errorSave('Server response error: ' + e))
  }
}

/*checkDiscountCode*/
export function* checkDiscountCode(api, authApi, {code}) {
  try {
    yield delay(1000)
    if (code === 'ad_spot') {
      yield put(SettingsActions.checkDiscountCodeSuccess(10))
    } else {
      yield put(SettingsActions.checkDiscountCodeFailure(true))
    }

    /*const response = yield call(api.checkDiscountCode, code)
    if (response && response.ok) {
      yield put(SettingsActions.checkDiscountCodeSuccess(response.data))
    } else {
      if (response && response.data) {
        if (response.status === 401) {
          yield put(ErrorsActions.errorSave(null))
        } else {
          yield put(ErrorsActions.errorSave(response.data))
        }
      } else {
        yield put(ErrorsActions.errorSave("Server response error"))
      }
      yield put(SettingsActions.checkDiscountCodeFailure(true))
      yield put(SettingsActions.settingsFetchingReset())
    }

    if (response && response.status === 401) {
      const res = yield call(authApi.tokenRefresh)
      if (res && res.access) {
        yield put(AuthActions.updateTokens(res.access, res.refresh))
        yield* checkDiscountCode(api, authApi, {code})
      } else {
        yield put(AuthActions.logout())
        yield put(push('/login'))
      }
    }*/
  } catch (e) {
    yield put(SettingsActions.settingsFetchingReset())
    yield put(ErrorsActions.errorSave('Server response error: ' + e))
  }
}

export function* savePaymentMethodMollie(api, authApi, {data}) {
  try {
    yield delay(1500)
    yield put(SettingsActions.savePaymentMethodMollieSuccess(true))
    //utils.goLink('http://192.168.10.140:3000/onboarding/step/payment/result/basic_plan_some_id')
    utils.goLink(data.link)

    /*const response = yield call(api.savePaymentMethodMollie, data)
    if (response && response.ok) {
      yield put(SettingsActions.savePaymentMethodMollieSuccess(true))
      utils.goLink(response.data.link)
    } else {
      if (response && response.data) {
        if (response.status === 401) {
          yield put(ErrorsActions.errorSave(null))
        } else if (response.status === 500) {
          yield put(SettingsActions.savePaymentMethodMollieFailure(true))
          yield put(ErrorsActions.errorSave(response.data))
        } else {
          yield put(ErrorsActions.errorSave(response.data))
        }
      } else {
        yield put(ErrorsActions.errorSave("Server response error"))
      }
      yield put(SettingsActions.settingsFetchingReset())
    }

    if (response && response.status === 401) {
      const res = yield call(authApi.tokenRefresh)
      if (res && res.access) {
        yield put(AuthActions.updateTokens(res.access, res.refresh))
        yield* savePaymentMethodMollie(api, authApi, {data})
      } else {
        yield put(AuthActions.logout())
        yield put(push('/login'))
      }
    }*/
  } catch (e) {
    yield put(SettingsActions.settingsFetchingReset())
    yield put(ErrorsActions.errorSave('Server response error: ' + e))
  }
}

export function* checkStatusPayment(api, authApi, {paymentId}) {
  try {
    yield delay(3000)
    yield put(SettingsActions.checkStatusPaymentSuccess(true))
    //yield put(SettingsActions.checkStatusPaymentFailure(true))

    /*const response = yield call(api.checkStatusPayment, paymentId)
    if (response && response.ok) {
      if(response.data.status === 'succeeded'){
        yield put(SettingsActions.checkStatusPaymentSuccess(true))
      } else {
        yield delay(2000)
        yield* checkStatusPayment(api, authApi, {paymentId})
      }
    } else {
      if (response && response.data) {
        if (response.status === 401) {
          yield put(ErrorsActions.errorSave(null))
        } else if (response.status === 500) {
          yield put(SettingsActions.checkStatusPaymentFailure(true))
          yield put(ErrorsActions.errorSave(response.data))
        } else {
          yield put(ErrorsActions.errorSave(response.data))
        }
      } else {
        yield put(ErrorsActions.errorSave("Server response error"))
      }
      yield put(SettingsActions.settingsFetchingReset())
    }

    if (response && response.status === 401) {
      const res = yield call(authApi.tokenRefresh)
      if (res && res.access) {
        yield put(AuthActions.updateTokens(res.access, res.refresh))
        yield* checkStatusPayment(api, authApi, {paymentId})
      } else {
        yield put(AuthActions.logout())
        yield put(push('/login'))
      }
    }*/
  } catch (e) {
    yield put(SettingsActions.settingsFetchingReset())
    yield put(ErrorsActions.errorSave('Server response error: ' + e))
  }
}
